import React from "react";
import styled from "styled-components";

interface BottomSheetBaseProps {
  onClose: () => void;
  children: React.ReactNode;
}

export const BottomSheetBase = ({
  onClose,
  children,
}: BottomSheetBaseProps) => (
  <Overlay onClick={onClose}>
    <Sheet onClick={(e) => e.stopPropagation()}>{children}</Sheet>
  </Overlay>
);

export function CloseSvg() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
        fill="#000"
      />
    </svg>
  );
}

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 500;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

const Sheet = styled.div`
  width: 100%;
  max-width: 480px;
  max-height: 80vh;
  background: #fff;
  border-radius: 20px 20px 0 0;
  display: flex;
  flex-direction: column;
  animation: bs-slide-up 0.25s ease-out;

  @keyframes bs-slide-up {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
`;

export const BSHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 24px 16px 16px;
  flex-shrink: 0;
`;

export const BSCloseBtn = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
`;

export const BSTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 900;
  color: #000;
`;

export const BSFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  padding-bottom: max(20px, env(safe-area-inset-bottom));
  border-top: 1px solid #d8d8d8;
  flex-shrink: 0;
`;

export const BSResetBtn = styled.button`
  background: none;
  border: none;
  font-size: 18px;
  font-weight: 900;
  color: #008cff;
  cursor: pointer;
  padding: 0;

  &:disabled {
    color: #cbcbcb;
    cursor: not-allowed;
    pointer-events: none;
  }
`;
